import React from 'react';
import { Drawer, Button } from 'antd';
import { Link } from 'react-router-dom';
import '../assets/styles/PopupDrawer.css';

const offers = [
  { title: 'AI-Powered Learning Path', text: 'Get personalized AI course recommendations tailored to your skills.', path: '/courses' },
  { title: 'Join AI Hackathons', text: 'Solve real-world AI challenges and win prizes.', path: '/challenges' },
  { title: 'Live AI Mentorship', text: 'Connect with AI experts for 1:1 coaching.', path: '/mentorship' },
  { title: 'AI Job Matching', text: 'Find AI jobs and internships with our smart matching tool.', path: '/jobs' },
  { title: 'AI Freelance Marketplace', text: 'Work on exciting AI projects as a freelancer.', path: '/freelance' },
  { title: 'Company AI Training', text: 'Partner with us for sponsored AI programs.', path: '/participants' },
  { title: 'Online AI Course - Tuition-Free', text: 'Learn AI from scratch, tuition-free, for African students.', path: '/courses' },
  { title: 'Cybersecurity for Africa', text: 'Free online training to secure Africa’s digital future.', path: '/courses' },
];

const newsItems = [
  { text: 'AI Hackathon starts next week!', link: '/challenges' },
  { text: 'New AI job listings added daily.', link: '/jobs' },
  { text: 'Join our open-source AI projects.', link: '/research' },
];

const ExclusiveOffersDrawer = ({ visible, onClose }) => {
  return (
    <Drawer
      title="Exclusive Offers"
      placement="right"
      closable
      onClose={onClose}
      open={visible}
      width={300}
      bodyStyle={{ padding: '16px', overflowY: 'auto', backgroundColor: '#fff', minHeight: '200px' }}
      className="exclusive-offers-drawer"
    >
      <div className="offers-content">
        {offers.map((offer, index) => (
          <div
            key={index}
            className="offer-item"
            style={{ borderBottom: '1px solid #e8e8e8', paddingBottom: '16px', marginBottom: '16px' }}
          >
            <h3 style={{ margin: 0, fontSize: '16px', color: '#1e90ff' }}>{offer.title}</h3>
            <p style={{ margin: '8px 0', fontSize: '14px', color: '#595959' }}>{offer.text}</p>
            <Link to={offer.path || '/signup'}>
              <Button type="primary" size="small" className="apply-now-button">
                Apply Now
              </Button>
            </Link>
          </div>
        ))}
        <div className="news-container">
          <div className="news-scroll">
            {newsItems.map((item, index) => (
              <p key={index} style={{ margin: '8px 0', fontSize: '12px', color: '#000' }}>
                <a href={item.link} className="news-link">
                  {item.text}
                </a>
              </p>
            ))}
          </div>
        </div>
      </div>
    </Drawer>
  );
};

export default ExclusiveOffersDrawer;